import { render, staticRenderFns } from "./RespondsTableTab.vue?vue&type=template&id=c108a47c&scoped=true"
import script from "./RespondsTableTab.vue?vue&type=script&lang=js"
export * from "./RespondsTableTab.vue?vue&type=script&lang=js"
import style0 from "./RespondsTableTab.vue?vue&type=style&index=0&id=c108a47c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c108a47c",
  null
  
)

export default component.exports